// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"5295b03b","453":"0137d07e"}[chunkId] + ".chunk.js";
};